import React from 'react'
import styled from 'styled-components'
import Fondo from './Fondo'
import Titulo from './Titulo'
import { Icon } from '@iconify/react/dist/iconify.js'
import { ICON_TYPES } from '../constantes/iconos.ts'

const Donaciones = ({ cambiar }) => {
    return (
        <Fondo>
            <Container>
                <Salida onClick={() => cambiar()} >
                    X
                </Salida>
                <Cabecera>
                    <Icon icon={ICON_TYPES.DONACION} style={{ fontSize: '70px' }} />
                    <Titulo titulo='DONACIONES' color='black' />
                </Cabecera>
                <Lista>
                    <Li>Numero de Cuenta</Li>
                    <Li>00915703810</Li>
                    <Li>Fundación Medellín amiga</Li>
                    <Li>Ahorros Bancolombia ba</Li>
                </Lista>
            </Container>
        </Fondo>
    )
}

const Container = styled.div`
    width: 80vw;
    height: 80vh;
    border-radius: 20px;
    background-color: #bbb;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    position: relative;
`

const Cabecera = styled.div`
    display: flex;
    flex-wrap: no-wrap;
    width: 90%;
    justify-content: space-between;
    align-items: center;
`
const Salida = styled.button`
    height: 30px;
    width: 30px;
    background-color: var(--secundary);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(30%,-30%);
    color: white;
    cursor: pointer
`
const Lista = styled.ul`
    width: 90%;
    text-align: center;
`
const Li = styled.li`
    font-size: 200%;
`

export default Donaciones